import moment from "moment";

export const columns = [
    {
      title: '手机号',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
    },
    {
      title: '用户ID',
      dataIndex: 'userId',
      key: 'userId',
    },
    {
      title: '姓名',
      dataIndex: 'userName',
      key: 'userName',
    },

    {
      title: '原因',
      dataIndex: 'reason',
      key: 'reason',
        scopedSlots: { customRender: "reason" },
    },
    {
      title: '创建人',
      dataIndex: 'createName',
      key: 'createName',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
        customRender: (text) =>  {
           if(text) {
               return moment(text).format('YYYY-MM-DD HH:mm:ss')
           } else {
               return '-'
           }
        }
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
    },
]